import React from 'react'
import realEstateAsset from "../../images/Group 11921.svg";
import vehicleAsset from "../../images/Group 11922.svg";
import buyAndSellAsset from "../../images/Group 11923.svg";
import lisetAsset from "../../images/Group 11924.svg";
import strings from '../../utils/locals/languages';

const WhatToDo = () => {
    return (
        <div className="container mt-4 mb-4 ">
            <div className="shadow-md bg-white rounded-[10px] ">
                <div className="flex justify-content-center pt-[20px] underline ">

                    {strings.whatDo}
                </div>

                <div className="row section">
                    <div className="col-12 flex flex-col items-center col-md-6 col-lg-3 ">
                        <img src={realEstateAsset} alt="" />
                        <h6
                            className="text-center mt-4 fw-bold"
                            style={{ fontSize: "12px" }}
                        >
                            {strings.findPlace}
                        </h6>
                        <p
                            style={{
                                fontSize: "10px",
                                opacity: "0.6",
                                textAlign: "center",
                            }}
                        >
                            {strings.findPlaceText.slice(0, 80)}
                        </p>
                    </div>

                    <div className="col-12 flex flex-col items-center col-md-6 col-lg-3 ">
                        <img src={vehicleAsset} alt="" />
                        <h6
                            className="text-center mt-4 fw-bold"
                            style={{ fontSize: "12px" }}
                        >
                            {strings.findVehicle}
                        </h6>

                        <p
                            style={{
                                fontSize: "10px",
                                opacity: "0.6",
                                textAlign: "center",
                            }}
                        >
                            {strings.findVehicleText.slice(0, 80)}
                        </p>
                    </div>

                    <div className="col-12 flex flex-col items-center col-md-6 col-lg-3 ">
                        <img src={buyAndSellAsset} alt="" />
                        <h6
                            className="text-center mt-4 fw-bold"
                            style={{ fontSize: "12px" }}
                        >
                            {strings.buyRent}
                        </h6>
                        <p
                            style={{
                                fontSize: "10px",
                                opacity: "0.6",
                                textAlign: "center",
                            }}
                        >
                            {strings.buyRentText.slice(0, 80)}
                        </p>
                    </div>

                    <div className="col-12 flex flex-col items-center col-md-6 col-lg-3 ">
                        <img src={lisetAsset} alt="" />
                        <h6
                            className="text-center mt-4 fw-bold"
                            style={{ fontSize: "12px" }}
                        >
                            {strings.listAdd}
                        </h6>
                        <p
                            style={{
                                fontSize: "10px",
                                opacity: "0.6",
                                textAlign: "center",
                            }}
                        >
                            {strings.listAddText.slice(0, 80)}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatToDo